__cw__define(['jquery'], function ($) {
  var init = function init() {
    var tabbableItem = 'select, input, textarea, button, a';
    function trapFocus(elem) {
      var tabbable = elem.find(tabbableItem).filter(':visible');
      var firstTabbable = tabbable.first();
      var lastTabbable = tabbable.last();
      tabbable.removeAttr('tabindex');
      firstTabbable.unbind().focus();
      lastTabbable.on('keydown', function (e) {
        if (e.which === 9 && !e.shiftKey) {
          e.preventDefault();
          firstTabbable.focus();
        }
      });
      firstTabbable.on('keydown', function (e) {
        if (e.which === 9 && e.shiftKey) {
          e.preventDefault();
          lastTabbable.focus();
        }
      });
    }
    function openNav() {
      $('#toggle-mobile-nav').attr('aria-expanded', 'true').attr('aria-label', 'Close');
      $('body').addClass('nav-active');
      var navElem = $('.nav-container');
      navElem.attr('aria-hidden', 'false');
      trapFocus(navElem);
      navElem.on('keyup', function (e) {
        if (e.keyCode === 27) {
          closeNav();
        }
      });
    }
    function closeNav() {
      $('#toggle-mobile-nav').attr('aria-expanded', 'false').attr('aria-label', 'Open').focus();
      $('.nav-container').attr('aria-hidden', 'true').find(tabbableItem).attr('tabindex', '-1').unbind();
      $('body').removeClass('nav-active');
    }
    function openSearch() {
      $('#toggle-mobile-recherche').attr('aria-expanded', 'true').attr('aria-label', 'Close');
      $('body').addClass('recherche-active');
      var searchElem = $('.menu-secondaire');
      searchElem.attr('aria-hidden', 'false');
      trapFocus(searchElem);
      setInert($('#q'), false);
      searchElem.on('keyup', function (e) {
        if (e.keyCode === 27) {
          closeSearch();
        }
      });
    }
    function closeSearch() {
      $('#toggle-mobile-recherche').attr('aria-expanded', 'false').attr('aria-label', 'Open').focus();
      $('.menu-secondaire').attr('aria-hidden', 'true').find(tabbableItem).attr('tabindex', '-1').unbind();
      $('body').removeClass('recherche-active');
      setInert($('#q'), true);
    }
    function setInert(elem, value) {
      if (value) {
        elem.attr('inert', '');
      } else {
        elem.removeAttr('inert');
      }
    }
    $('#toggle-mobile-nav').click(function () {
      closeSearch();
      var headerContainer = document.querySelector('.ia-header-microsites-container');
      var fixedCssClass = 'header-fixed';
      if ($(this).attr('aria-expanded') == 'false') {
        openNav();
        if (headerContainer) headerContainer.classList.add(fixedCssClass);
      } else {
        closeNav();
        if (headerContainer) headerContainer.classList.remove(fixedCssClass);
      }
    });
    $('#toggle-mobile-recherche').click(function () {
      closeNav();
      if ($(this).attr('aria-expanded') == 'false') {
        openSearch();
      } else {
        closeSearch();
      }
    });
    $(window).on('load resize', function () {
      if ($(window).width() >= 1140) {
        closeNav();
        closeSearch();
        $('.nav-container, .menu-secondaire').attr('aria-hidden', 'false').find(tabbableItem).removeAttr('tabindex');
        // $('body').find(tabbableItem).first().focus();
        setInert($('#q'), false);
      }
    });
    $('.top-nav').on('click', '.dropdown-toggle', function () {
      var dropdownMenu = $(this).next('.dropdown-menu');
      var menuPrincipal = $('ul.menu-principal');
      dropdownMenu.stop(true, true).fadeToggle(function () {
        if (dropdownMenu.is(':visible')) {
          menuPrincipal.addClass('signin-open');
        } else {
          menuPrincipal.removeClass('signin-open');
        }
      });
    });
    $(document).on('click', function (event) {
      var dropdown = $('.dropdown-menu');
      var toggle = $('.dropdown-toggle');
      if (!dropdown.is(event.target) && dropdown.has(event.target).length === 0 && !toggle.is(event.target) && toggle.has(event.target).length === 0) {
        dropdown.fadeOut();
        $('ul.menu-principal').removeClass('signin-open');
      }
    });
    $('.dropdown-toggle').on('keydown', function (event) {
      if (event.which === 13) {
        $(this).next('.dropdown-menu').fadeIn();
        $(this).next('.dropdown-menu').find('a').first().focus();
        $('ul.menu-principal').addClass('signin-open');
      }
    });
    $('.dropdown-menu').on('focusout', function (event) {
      if (!$(this).has(event.relatedTarget).length) {
        var dropdownMenu = $(this);
        setTimeout(function () {
          dropdownMenu.fadeOut();
          $('ul.menu-principal').removeClass('signin-open');
        }, 200);
      }
    });
    $(document).ready(function () {
      var bannerItem = $('.bandeau-alerte-haut-wrapper:not(.always-displayed)');
      var alwaysDisplayedBanner = $('.bandeau-alerte-haut-wrapper.always-displayed');
      var bannerBtn = $('.close-bandeau-alerte-haut');
      var bannerCookie = sessionStorage.getItem('bannerState');
      var navContainer = $('.nav-container');
      if (bannerCookie) {
        bannerItem.removeClass('opened');
      } else {
        bannerItem.addClass('opened');
      }
      if (alwaysDisplayedBanner.length > 0 || bannerItem.hasClass('opened')) {
        navContainer.addClass('alert-actif');
      }
      bannerBtn.on('click', function () {
        bannerItem.removeClass('opened');
        sessionStorage.setItem('bannerState', 'closed');
        navContainer.removeClass('alert-actif');
      });
    });
  };
  return {
    init: init
  };
});